<template>
    <div>

        <v-container fluid
                     style="background-color:#fff;">

            <v-form
                    ref="form">
                <v-row align="center"
                       class="pl-1"
                       no-gutters>
                    <v-col md="auto">
                        共享设备管理方
                    </v-col>
                    <v-col
                            class="pl-6"
                            cols="3">
                        <z-source-selector :search="true"
                                           label="请选择部门"
                                           :hide-details="'auto'"
                                           :rules="manageDeptRules"
                                           v-model="batchAddRequest.assetsManageDeptId"
                                           :source="'DeptSelector'"
                        ></z-source-selector>
                    </v-col>
                    <v-col
                            cols="6">
                    </v-col>
                </v-row>

                <v-row align="center"
                       no-gutters
                       class="pl-1">
                    <v-col md="auto">
                        共享设备所有方
                    </v-col>
                    <v-col
                            class="pl-6"
                            cols="3">
                        <z-source-selector :search="true"
                                           @changevalue="changeOwnerDeptId"
                                           label="请选择部门"
                                           :hide-details="'auto'"
                                           :rules="[v => !!v||'部门必输']"
                                           v-model="batchAddRequest.propertyOwnerDeptId"
                                           :source="'DeptSelector'"
                        ></z-source-selector>
                    </v-col>
                    <v-col
                            align="right"
                            class="pt-0"
                            cols="7">
                        <v-btn
                                :disabled="selectEqp.length<1"
                                color="primary"
                                @click="handleBatchAdd"
                        >
                            确认添加 ({{selectEqp.length}})
                        </v-btn>
                        <v-btn
                                color="primary"
                                class="ma-2"
                                @click="addShareAssets">
                            自定义添加共享设备
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>

        </v-container>

        <v-form
                ref="queryForm"
                class="pb-6"
        >
            <v-row class="pl-4"
                   style="height: 60px"
            >
                <v-col
                        cols="2"
                        class="pr-0 pb-0"
                >
                    <v-text-field
                            hide-details="auto"
                            clearable
                            label="设备名称"
                            single-line
                            v-model="queryRequest.eqpName"
                    ></v-text-field>
                </v-col>

                <v-col
                        cols="2"
                        class="pr-0 pb-0"
                >
                    <v-text-field
                            hide-details="auto"
                            clearable
                            label="品牌"
                            single-line
                            v-model="queryRequest.eqpBrand"
                    ></v-text-field>
                </v-col>

                <v-col
                        cols="2"
                        class="pr-0 pb-0"
                >
                    <v-text-field
                            hide-details="auto"
                            clearable
                            label="设备型号"
                            single-line
                            v-model="queryRequest.eqpModel"
                    ></v-text-field>
                </v-col>
                <!--<v-col cols="4">-->

                <!--</v-col>-->
                <v-col
                        cols="5"
                        class="pr-0 pb-0"
                        align="right"
                >
                    <v-btn
                            color="primary"
                            :loading="loading.query"
                            @click="query"
                    >
                        搜索
                        <v-icon right>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn
                            color="primary"
                            class="ma-2"
                            @click="resetQuery"
                    >
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row class="pl-4">
                <v-col
                        cols="2"
                        class="pr-0 pb-0"
                >
                    <v-text-field
                            clearable
                            label="出厂序列号"
                            hide-details="auto"
                            single-line
                            v-model="queryRequest.factSerialNo"
                    ></v-text-field>
                </v-col>

                <v-col
                        cols="2"
                        class="pr-0 pb-0"
                >
                    <v-text-field
                            clearable
                            label="设备编号"
                            hide-details="auto"
                            single-line
                            v-model="queryRequest.hospEqpId"
                    ></v-text-field>
                </v-col>

                <!--<v-col cols="6">-->

                <!--</v-col>-->

                <v-col
                        cols="7"
                        align="right"
                >
                </v-col>
            </v-row>
        </v-form>


        <v-row justify="center">
            <v-col
                    cols="11">
                <v-card>
                    <v-card-title>
                        设备信息
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-data-table
                            :single-select="false"
                            show-select
                            :options.sync="tableOptions"
                            v-model="selectEqp"
                            :page.sync="queryRequest.pagedQueryInfo.index"
                            :server-items-length="total"
                            :headers="deptHeaders"
                            :items="tableData"
                            :footer-props="footerOptions"
                    >
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>


        <!--设备文件导入弹框 start-->
        <v-dialog
                v-model="uploadDialog"
                max-width="60%">
            <div style="background-color:#fff;" class="pb-12">
                <v-card-title class="font-weight-bold">
                    <div class="d-flex align-center justify-space-between"
                         style="width:100%;">
                        <span>上传文件</span>
                        <v-btn color="primary" @click="getMould">获取模板</v-btn>
                    </div>
                </v-card-title>
                <v-row no-gutters justify="center">
                    <v-col
                            cols="6">
                        <v-form
                                ref="uploadFileForm"
                                v-model="uploadFormValid"
                        >
                            <v-file-input
                                    v-model="fileInfo"
                                    required
                                    :rules="[v => !!v || '文件必选']"
                                    show-size accept=".xls,.xlsx"
                                    @change="uploadFile"
                                    :disabled="loading.uploadIsLoading"
                                    :loading="loading.uploadIsLoading"
                                    label="点击选择文件，文件格后缀为：.xls、.xlsx"></v-file-input>
                        </v-form>

                    </v-col>
                </v-row>

                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">导入数据总数:100</v-col>-->
                <!--</v-row>-->
                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">处理失败数量:10</v-col>-->
                <!--</v-row>-->
                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">成功数量:20</v-col>-->
                <!--</v-row>-->
                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">更新已存在设备信息数量:30</v-col>-->
                <!--</v-row>-->
                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">新增设备录入数量:40</v-col>-->
                <!--</v-row>-->
                <!--<v-row no-gutters>-->
                <!--<v-col class="text-right" cols="6">处理耗时:0</v-col>-->
                <!--</v-row>-->

            </div>
        </v-dialog>
        <!--设备文件导入弹框 end-->

        <z-loading v-model="isShowLoading"></z-loading>

        <z-notify ref="notify"></z-notify>
    </div>
</template>

<script>
  import {
    eqpPageQuery,
    assetsTemplate,
    batchAdd,
    assetsFileInput
  } from '@/api/assetsManagement'
  import reportDownLoad from "@/utils/reportDownLoad"

  export default {
    name: "AddAssets",
    data() {
      return {
        isShowLoading: false,
        uploadDialog: false,
        uploadFormValid: true,
        fileInfo: null,
        total: 0,
        loading: {
          query: false,
          uploadIsLoading: false,
        },
        tableOptions: {},
        tableData: [],
        selectEqp: [],
        deptHeaders: [
          {
            text: '设备名称',
            align: 'left',
            sortable: false,
            value: 'eqpName',
            width: '15%'
          },
          {
            text: '品牌',
            align: 'start',
            sortable: false,
            value: 'eqpBrand'
          },
          {
            text: '型号',
            align: 'start',
            sortable: false,
            value: 'eqpModel'
          },
          {
            text: '出厂序列号',
            align: 'start',
            sortable: false,
            value: 'factSerialNo'
          },
          {
            text: '设备编号',
            align: 'start',
            sortable: false,
            value: 'hospEqpId'
          },
          {
            text: '出厂日期',
            align: 'start',
            sortable: false,
            value: 'productionDate'
          },
          {
            text: '安装日期',
            align: 'start',
            sortable: false,
            value: 'installDate'
          },
        ],
        queryRequest: {
          deptId: '',
          eqpName: '',
          eqpModel: '',
          eqpBrand: '',
          hospEqpId: '',
          factSerialNo: '',
          pagedQueryInfo: {
            index: 1,
            pageSize: 10
          },
        },
        equipmentInfo: {
          eqpId: "",
          eqpName: "",
          eqpBrand: "",
          eqpModel: "",
          factSerialNo: "",
          installDate: "",
          nationLevel1: "",
          nationLevel2: "",
          nationLevel3: "",
          productionDate: "",
          specification: "",
          tagName: "",
          unitPrice: 0
        },
        batchAddRequest: {
          equipmentInfoList: [],
          propertyOwnerDeptId: "",
          assetsManageDeptId: ""
        },
        manageDeptRules: [],
        footerOptions:{
          itemsPerPageOptions:[10,30,100,500]
        }
      }
    },
    watch: {
      tableOptions: {
        handler(val) {
          console.log(this.queryRequest.pagedQueryInfo.index, 'this.queryRequest.pagedQueryInfo.index');
          console.log(this.queryRequest.pagedQueryInfo.pageSize, 'this.queryRequest.pagedQueryInfo.pageSize');
          if (val.itemsPerPage == -1) {
            this.queryRequest.pagedQueryInfo.index = 1
            this.queryRequest.pagedQueryInfo.pageSize = 999999
          } else if (!val.itemsPerPage && !val.page) {

          } else {
            this.queryRequest.pagedQueryInfo.index = val.page;
            this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage;
          }

          this.handleQuery();
        }
      }
    },
    methods: {
      changeOwnerDeptId() {
        this.query();
        this.selectEqp = [];
      },
      resetQuery() {
        this.$refs.form.reset();
        this.tableData = [];
        this.queryRequest = {
          deptId: '',
          eqpName: '',
          eqpModel: '',
          eqpBrand: '',
          hospEqpId: '',
          factSerialNo: '',
          pagedQueryInfo: {
            index: 1,
            pageSize: 10
          },
        };
      },
      query() {
        this.queryRequest.pagedQueryInfo.index = 1;
        this.handleQuery();
      },
      //查询部门下的设备信息
      handleQuery() {
        this.manageDeptRules = [];
        this.$nextTick((res) => {
          if (this.$refs.form.validate()) {
            this.loading.query = true;
            this.queryRequest.deptId = this.batchAddRequest.propertyOwnerDeptId;
            eqpPageQuery(this.queryRequest).then(res => {
              this.tableData = res.list;
              this.total = res.total;
              this.loading.query = false
            }).catch(err => {
              this.loading.query = false
            });
          }
        });
      },
      //批量新增设备信息
      handleBatchAdd() {
        console.log(this.selectEqp)
        this.manageDeptRules = [v => !!v || '部门必输'];
        this.$nextTick((res) => {
          if (!this.$refs.form.validate()) {
            return;
          } else {
            this.batchAddRequest.equipmentInfoList = [];
            this.selectEqp.forEach(item => {
              let res = JSON.parse(JSON.stringify(item));
              this.equipmentInfo = res
              this.equipmentInfo.eqpId = res.id
              this.batchAddRequest.equipmentInfoList.push(this.equipmentInfo);
            })
            this.batchAddRequest.propertyOwnerDeptId = this.queryRequest.deptId
            batchAdd(this.batchAddRequest).then(res => {
              this.$refs.notify.show("开通成功", {timeout: 1000, color: "green"})
              this.resetQuery();
              this.selectEqp = this.$options.data().selectEqp;
              this.batchAddRequest = this.$options.data().batchAddRequest;
            }).catch(err => {
              this.loading = false
            })
          }
        });
      },
      addShareAssets() {
        if(!this.batchAddRequest.propertyOwnerDeptId ){
          this.$refs.notify.show("未输入所属部门", {timeout: 1000, color: 'red'});
          return ;
        }
        if(!this.batchAddRequest.assetsManageDeptId ){
          this.$refs.notify.show("未输入管理部门", {timeout: 1000, color: 'red'});
          return ;
        }
        this.uploadDialog = true;
      },
      // 上传文件方法
      uploadFile() {
        if (this.$refs.uploadFileForm.validate()) {
          this.loading.uploadIsLoading = true;
          var formData = new window.FormData();
          //新增资产管理部门和所属部门字段
          formData.append('file', this.fileInfo);
          formData.append('assetsManageDeptId', this.batchAddRequest.assetsManageDeptId);
          formData.append('propertyOwnerDeptId', this.batchAddRequest.propertyOwnerDeptId);
          assetsFileInput(formData).then(res => {
            this.loading.uploadIsLoading = false;
            this.$refs.notify.show("文件上传成功", {timeout: 1000, color: 'success'});
            this.uploadDialog = false;
            this.query();
          }).catch(err => {
            this.loading.uploadIsLoading = false;
          });
        }
      },
      getMould() {
        this.isShowLoading = true;
        assetsTemplate({}).then(res => {
          this.isShowLoading = false;
          reportDownLoad(res);
        }).catch(err => {
          this.isShowLoading = false;
        });
      },
    },
    created() {

    },
    mounted() {

    }
  }
</script>

<style scoped>

</style>